"use strict";

exports.__esModule = true;
exports.TravellerClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _constants = require("../constants");
const TravellerClient = {
  /**
   * @description Fetch traveller By Id
   * @param {string} id
   * @returns {Promise<MyAccount.RawTraveller>}
   */
  fetch(id) {
    const requestId = 'TRAVELLER';
    const endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.TRAVELLER, {
      id
    });
    return _http.$http.get(requestId, endPoint).then(({
      data
    }) => data);
  },
  /**
   * @description Fetch all Travellers
   * @returns {Promise<MyAccount.RawTraveller[]>}
   */
  fetchAll(isV4 = false) {
    const requestId = 'TRAVELLERS';
    const endPoint = isV4 ? _constants.ENDPOINTS.TRAVELLERS_V4 : _constants.ENDPOINTS.TRAVELLERS;
    return _http.$http.get(requestId, endPoint).then(({
      data
    }) => data);
  },
  /**
   * @description Update the user based on userId
   * @param {MyAccount.RawTraveller} traveller
   *
   * @returns {Promise<MyAccount.RawTraveller>}
   *
   */
  create(traveller, isV4) {
    const requestId = 'CREATE_TRAVELLER';
    const endPoint = isV4 ? _constants.ENDPOINTS.CREATE_TRAVELLER_V4 : _constants.ENDPOINTS.CREATE_TRAVELLER;
    return _http.$http.post(requestId, endPoint, {
      data: traveller
    }).then(({
      data
    }) => data);
  },
  /**
   * @description Update a traveller by id and data
   * @param {string} id
   * @param {MyAccount.RawTraveller} traveller
   *
   * @returns {Promise<MyAccount.RawTraveller>}
   *
   */
  update(id, traveller, isV4) {
    const requestId = 'UPDATE_TRAVELLER';
    const endPoint = (0, _client.replaceParams)(isV4 ? _constants.ENDPOINTS.UPDATE_TRAVELLER_V4 : _constants.ENDPOINTS.UPDATE_TRAVELLER, {
      id
    });
    return _http.$http.put(requestId, endPoint, {
      data: traveller
    }).then(({
      data
    }) => data);
  },
  /**
   * @description Delete a traveller by id
   * @param {string} id
   *
   * @returns {Promise}
   *
   */
  delete(id, isV4) {
    const requestId = 'DELETE_TRAVELLER';
    const endPoint = (0, _client.replaceParams)(isV4 ? _constants.ENDPOINTS.UPDATE_TRAVELLER_V4 : _constants.ENDPOINTS.UPDATE_TRAVELLER, {
      id
    });
    return _http.$http.delete(requestId, endPoint).then(({
      data
    }) => data);
  }
};
exports.TravellerClient = TravellerClient;